
import { Component, Vue, Prop} from 'vue-property-decorator';
import { childGaInfoType } from '@/types/Application/GuardianshipAffidavit';
import * as SurveyVue from "survey-vue";
import surveyJson from "./forms/survey-childInfo.json";
import * as surveyEnv from "@/components/survey/survey-glossary";

@Component
export default class ChildrenSurvey extends Vue {
    
    @Prop({required: true})
    editRowProp!: Object;
    
    child = {} as childGaInfoType;

    survey = new SurveyVue.Model(surveyJson);
    currentStep =0;
    currentPage =0;

    beforeCreate() {
        const Survey = SurveyVue;
        surveyEnv.setCss(Survey);       
    }

    mounted(){
        this.initializeSurvey();
        this.addSurveyListener();
        this.reloadPageInformation();
    }

    public initializeSurvey(){
        this.survey = new SurveyVue.Model(surveyJson);
        this.survey.commentPrefix = "Comment";
        this.survey.showQuestionNumbers = "off";
        this.survey.showNavigationButtons = false;
        surveyEnv.setGlossaryMarkdown(this.survey);
    }
    
    public addSurveyListener(){       
        this.survey.onComplete.add((sender, options) => {
            this.populateChildModel(sender.data);
            let id = sender.getVariable("id");
            if (id === null || id === undefined) {
                this.$emit("surveyData", this.child);
            } else {
                this.$emit("editedData", { ...this.child, id });
                id = null;
            }
        });
    }
    
    public reloadPageInformation() {
        if (this.editRowProp != null) {
            this.populateFormWithPreExistingValues(this.editRowProp, this.survey);
        } else {
            this.survey.setValue("currentGuardiansToChild", []);
            this.survey.setValue("parentsNotGuardians", []);
        }
        
        let progress = 50;
        if(Object.keys(this.survey.data).length)
            progress = this.survey.isCurrentPageHasErrors? 50 : 100;
            
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        this.$store.commit("Application/setPageProgress", { currentStep: this.currentStep, currentPage:this.currentPage, progress:progress })      
    }
  
    public goBack() {
        this.$emit("showTable", true);
    }
    
    public saveChild() {
        
        this.survey.completeLastPage();
    }

    public populateChildModel(childData) {
        if(childData){
            this.child.name = childData.name;       
            this.child.dob = childData.dob;
            this.child.currentGuardiansToChild = childData.currentGuardiansToChild;
            this.child.parentsNotGuardiansExist = childData.parentsNotGuardiansExist;
            this.child.parentsNotGuardians = childData.parentsNotGuardians;
            this.child.relationWithchild = childData.relationWithchild;
            this.child.lengthOfRelationship = childData.lengthOfRelationship;
            this.child.currentLiving = childData.currentLiving;
        }
    }

    public populateFormWithPreExistingValues(editRowProp, survey) {
        survey.data = {
            name: { first: editRowProp.name.first, middle: editRowProp.name.middle, last: editRowProp.name.last }
        };        
        survey.setValue("dob", editRowProp.dob);
        survey.setValue("currentGuardiansToChild", editRowProp.currentGuardiansToChild);
        survey.setValue("parentsNotGuardiansExist", editRowProp.parentsNotGuardiansExist);
        survey.setValue("parentsNotGuardians", editRowProp.parentsNotGuardians);
        survey.setValue("relationWithchild", editRowProp.relationWithchild);
        survey.setValue("lengthOfRelationship", editRowProp.lengthOfRelationship);
        survey.setValue("currentLiving", editRowProp.currentLiving);
        survey.setVariable("id", editRowProp.id);
    }

    beforeDestroy() {
        const progress = this.survey.isCurrentPageHasErrors? 50 : 100;
        this.$store.commit("Application/setPageProgress", { currentStep: this.currentStep, currentPage:this.currentPage, progress:progress })
    }
}
